import { render, staticRenderFns } from "./InboxContents.vue?vue&type=template&id=501d9d5e&scoped=true"
import script from "./InboxContents.vue?vue&type=script&lang=js"
export * from "./InboxContents.vue?vue&type=script&lang=js"
import style0 from "./InboxContents.vue?vue&type=style&index=0&id=501d9d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501d9d5e",
  null
  
)

export default component.exports